<h3 mat-dialog-title>Testname: {{ rowFromOutputList.test_name }}</h3>
<mat-dialog-content>
  <p class="mat-body">
    <b>Start</b>: {{rowFromOutputList.created_at | date: 'medium'}}
    <b>End</b>: {{rowFromOutputList.completed_at | date: 'medium'}}
  </p>

  <mat-tab-group mat-stretch-tabs="True" mat-align-tabs="center">
    <!-- Report Tab -->
    <mat-tab label="Report">
      <p><b>Title:</b> {{ reportData?.title }}</p>
      <p><b>Description:</b> {{ reportData?.description}}</p>
      <p><b>Result:</b> 
        <ng-container *ngIf="reportData?.result">
          <span *ngIf="reportData.result === 'green'"> Passed </span>
          <span *ngIf="reportData.result === 'red'"> Failed </span>
          <span class="result-circle" 
                [ngStyle]="{'background-color': getResultColor(reportData.result)}">
          </span>
        </ng-container>
      </p>
      <p><b>Test created at:</b> {{ rowFromOutputList.created_at | date:'medium' }}</p>
      <p><b>Test completed at:</b> {{ rowFromOutputList.completed_at | date:'medium' }}</p>
      <p>
        <a href="#" (click)="openTab('input'); $event.preventDefault();">Input</a>
      </p>
      <p>
        <a href="#" (click)="openTab('lastOutput'); $event.preventDefault();">Output</a>
      </p>
    </mat-tab>

    <!-- Output Tabs -->
    <!-- Output Tabs -->
<ng-container *ngFor="let item of dataOutput; index as i">
  <mat-tab label="Output {{ i + 1 }}">
    <h4>{{ item.name }}</h4>
    <p><b>Exit Code</b>: {{ item.exitCode}}</p>

    <ng-container *ngIf="item.errors && item.errors.length > 0; else elseErrors">
      <p><b>Errors:</b></p>
      <ng-container *ngFor="let error of item.errors">
        <p>{{ error }}</p>
      </ng-container>
    </ng-container>
    <ng-template #elseErrors>
      <p><b>Errors:</b> No errors found.</p>
    </ng-template>

    <ng-container *ngIf="item.assessment?.vulnerabilities; else elseVulnerabilities">
      <p><b>Vulnerabilities:</b> {{ item.assessment?.vulnerabilities }}</p>
    </ng-container>
    <ng-template #elseVulnerabilities>
      <p><b>Vulnerabilities:</b> No vulnerabilities found.</p>
    </ng-template>

    <ng-container *ngIf="item.assessment?.warnings; else elseWarnings">
      <p><b>Warnings:</b> {{ item.assessment?.warnings }}</p>
    </ng-container>
    <ng-template #elseWarnings>
      <p><b>Warnings:</b> No warnings found.</p>
    </ng-template>

    <ng-container *ngIf="!isEmpty(item.gatheringProperties)">
      <div class="toggle-button-container">
        <mat-button-toggle-group [(ngModel)]="viewMode" aria-label="View mode">
          <mat-button-toggle value="tree">
            <mat-icon>account_tree</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="table">
            <mat-icon>table_chart</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <ng-container *ngIf="viewMode == 'tree'">
        <aw-json-tree [jsonData]="item.gatheringProperties"></aw-json-tree>
      </ng-container>

      <ng-container *ngIf="viewMode == 'table'">
        <aw-json-table [value]="item.gatheringProperties"></aw-json-table>
      </ng-container>
    </ng-container>
  </mat-tab>
</ng-container>


    <!-- Input Tab -->
   <mat-tab label="Input">
  <h4>Input Data</h4>
    <div *ngIf="input; else loadingInputTab">
      <div class="toggle-button-container" *ngIf="!isEmpty(input)">
        <mat-button-toggle-group [(ngModel)]="viewMode" aria-label="View mode">
          <mat-button-toggle value="tree">
          <mat-icon>account_tree</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="table">
          <mat-icon>table_chart</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <ng-container *ngIf="viewMode === 'tree'">
      <aw-json-tree [jsonData]="input"></aw-json-tree>
    </ng-container>
    <ng-container *ngIf="viewMode === 'table'">
      <aw-json-table [value]="input"></aw-json-table>
    </ng-container>

    <ng-container *ngIf="isEmpty(input)">
      <pre>{{ input | json }}</pre>
    </ng-container>
  </div>
  <ng-template #loadingInputTab>Loading input data...</ng-template>
</mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial>Close</button>
</mat-dialog-actions>
